import { ModeForm } from "constants/enum";
import { UPDATE_SUCCESS_MESSAGE } from "constants/index";

import { Dispatch, SetStateAction } from "react";

import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from "@tanstack/react-query";
import {
  RequestCandidateEntity,
  useGetOneBaseRequestCandidateControllerRequestCandidateEntity,
  useUpdateOneBaseRequestCandidateControllerRequestCandidateEntity,
} from "generated";
import { useNotification } from "hooks/useNotification";
import { useParams } from "react-router-dom";

import { RequestCandidateForm } from "./RequestCandidateForm";

interface PropTypes {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>
  ) => Promise<QueryObserverResult<unknown, unknown>>;
  isModalOpen: boolean;
  updateId: string;
  mode: ModeForm;
}
export const RequestCandidateUpdateComponent = (props: PropTypes) => {
  const { setIsModalOpen, isModalOpen, updateId, refetch, mode } = props;
  const { id } = useParams();

  const { data, refetch: refetchData } =
    useGetOneBaseRequestCandidateControllerRequestCandidateEntity(updateId, {
      join: [`request`, `template`, `template.templateType`],
    });
  const {
    mutate: updateCadidate,
    error: updateError,
    isSuccess,
  } = useUpdateOneBaseRequestCandidateControllerRequestCandidateEntity({
    mutation: {
      onSuccess() {
        refetch();
        refetchData();
        setIsModalOpen(false);
      },
    },
  });

  const handleSubmit = (dataRequestCandidate: any) => {
    updateCadidate({
      data: {
        candidateName: dataRequestCandidate?.candidateName,
        code: dataRequestCandidate?.code,
        status: dataRequestCandidate?.status,
        templateId: dataRequestCandidate?.templateId?.value,
        dueDate: dataRequestCandidate?.dueDate,
        dateOfBirth: dataRequestCandidate?.dob,
        email: dataRequestCandidate?.email,
        phoneNumber: dataRequestCandidate?.phoneNumber,
        position: dataRequestCandidate?.position,
        candidateInfo: dataRequestCandidate?.candidate,
        obDate: dataRequestCandidate?.obDate,
        fileUrl: JSON.stringify(dataRequestCandidate?.fileUrl),
        consentForm: JSON.stringify(dataRequestCandidate?.consentForm),
        degree: JSON.stringify(dataRequestCandidate?.degree),
        description: dataRequestCandidate?.description,
        requestId: id as string,
      },
      id: updateId,
    });
  };
  useNotification(
    (updateError?.response?.data as any) ?? updateError, // eslint-disable-line
    isSuccess,
    UPDATE_SUCCESS_MESSAGE
  );
  return (
    <RequestCandidateForm
      title={`Checklist detail: ${
        mode === ModeForm.Edit ? "Update" : "View"
      } Candidate`}
      subTitle="Update candidate in the order list"
      handleSubmitForm={handleSubmit}
      setIsModalCreateOpen={setIsModalOpen}
      isModalOpen={isModalOpen}
      data={data?.data as RequestCandidateEntity}
      mode={mode}
    />
  );
};
